import { render, staticRenderFns } from "./partsInfo.vue?vue&type=template&id=48ce658c&"
import script from "./partsInfo.vue?vue&type=script&lang=js&"
export * from "./partsInfo.vue?vue&type=script&lang=js&"
import style0 from "./partsInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports